import { Component, OnInit, ViewChild } from '@angular/core';
import { SalesService, Users, UserRole, UserPermissions, BrandLeadUser, ApplianceRole } from 'src/app/shared/services/sales.service';
import { Table } from 'primeng/table';
import { Message } from 'primeng/api/message';
import { ConfirmationService } from 'primeng/api';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UntypedFormGroup, FormBuilder, Validators, UntypedFormControl, NgForm } from '@angular/forms';
import { ProductItem, ProductitemService } from 'src/app/shared/services/productitem.service';
import { statuslist } from 'src/app/shared/services/status.service';
import { Region, RegionsService } from 'src/app/shared/services/regions.service';
import { sectorslist, SectorsService } from 'src/app/shared/services/sectors.service';

import * as $ from 'jquery';

@Component({
  selector: 'app-usermanagement',
  templateUrl: './usermanagement.component.html',
  styleUrls: ['./usermanagement.component.scss']
})
export class UsermanagementComponent implements OnInit {

  public usersList: Users[] = new Array();
  public rolesList: UserRole[] = new Array();
  applianceRoleList : ApplianceRole[];
  public managersList: Users[];
  public userDTO: Users = new Users();
  public userPermissionList: UserPermissions[];
  public brandListUsers: BrandLeadUser[];
  public items: ProductItem[];
  sectorList: sectorslist[];
  public regionsList: Region[];
  msgs: Message[] = [];
  brandsMsgs: Message[] = [];
  permMsgs: Message[] = [];
  tagMsgs: Message[] = [];
  displayDialog: boolean = false;
  displayPermDialog: boolean = false;
  displayBrandLeadDialog: boolean = false;
  displayTagsDialog: boolean = false;
  myGroup: UntypedFormGroup;
  myPermissionGroup: UntypedFormGroup;
  addPermissionRowClass: String = "addPermissionRowClass";
  public userPermission: UserPermissions = new UserPermissions();
  hideSector: boolean = true;
  hideRegion: boolean = true;
  model: any = {};

  rolesDropdown: {label: String, value: String}[] = [];

  applianceRolesDropdown: {label: string, value: number}[] = [];

  selectedUserId: number;

  // Tag management
  userTags: any[] = [];
  availableTags: any[] = [];
  selectedTags: number[] = [];
  tagTypes: string[] = [];
  selectedTagType: string = '';
  currentUsername: string = ''; // To store current user's name for the dialog title

  logValue(event: any) {
    // console.log(event);
  }

  constructor(private sectorsService: SectorsService, private regionService: RegionsService, private salesService: SalesService, private confirmationService: ConfirmationService, private itemService: ProductitemService) {
    this.createForm();
  }

  async ngOnInit() {

    $("body").css("overflow-y", "hidden");
    await this.sectorsService.getsectorsList().toPromise().then(response => { this.sectorList = response; });
    await this.regionService.getRegions().subscribe(response => { this.regionsList = response; });
    await this.salesService.retrieveManagers().toPromise().then(response => { this.managersList = response; });
    await this.salesService.retrieveAllRoles().toPromise().then(response => {
      this.rolesList = response;
      this.rolesDropdown = this.rolesList.map(role => ({
        label: role.userRole,
        value: role.userRole
      }));
    });

    await this.salesService.retriveApplianceRoles().toPromise().then(response => {
      this.applianceRoleList = response;

      this.applianceRolesDropdown = this.applianceRoleList.map(role => ({
        label: String(role.roleName),
        value: role.roleId
      }));
    });

    await this.retrieveBrandLeadUsers();
    await this.itemService.getProductItems().toPromise().then(response => { this.items = response; });
    await this.retrieveUsers();

    $(".spinner-container").fadeOut();
    $("body").css("overflow-y", "auto");
  }

  createForm() {

    this.myGroup = new UntypedFormGroup({
      empId: new UntypedFormControl(null, [Validators.required]),
      firstName: new UntypedFormControl(null, [Validators.required]),
      lastName: new UntypedFormControl(null, [Validators.required]),
      email: new UntypedFormControl(null, [Validators.required, Validators.email]),
      manager: new UntypedFormControl(null, [Validators.required]),
      quota: new UntypedFormControl(null, [Validators.nullValidator]),
      role: new UntypedFormControl(null, [Validators.required]),
      applanceRole : new UntypedFormControl(null, [Validators.required]),
    });

    this.myPermissionGroup = new UntypedFormGroup({
      canEdit: new UntypedFormControl(null, [Validators.required]),
      canView: new UntypedFormControl(null, [Validators.required]),
      canDelete: new UntypedFormControl(null, [Validators.required]),
      canCreate: new UntypedFormControl(null, [Validators.required]),
      lob: new UntypedFormControl(null, [Validators.required]),
      sectorPerm: new UntypedFormControl(null, [Validators.required]),
      regionPerm: new UntypedFormControl(null, [Validators.required]),
    });
  }

  async retrieveBrandLeadUsers() {
    await this.salesService.retrieveBrandLeadUsers().toPromise().then(response => { this.brandListUsers = response; });
  }

  async retrieveUsers() {

    return this.salesService.retrieveAllUsers().subscribe(
      response => {
        this.usersList = new Array();
        response.forEach(userData => {
          populateManagerName(userData.managerId, this.managersList, userData);
          this.usersList.push(userData);
        });
      }
    );
  }

  openBrandLeadDialog(userId: number) {
    this.selectedUserId = userId;
    this.displayBrandLeadDialog = true;
  }

  closeBrandLeadDialog() {
    this.displayBrandLeadDialog = false;
  }

  @ViewChild('addUserForm') addUserForm;
  @ViewChild('f') f: NgForm;

  public submitForm() {
    this.addUserForm.nativeElement.submit();
  }

  createUser() {

    this.salesService.createUser(this.userDTO).subscribe(
      (data) => {
        this.showMsg('info', 'Confirmed', 'User Created Successfully !!!');
        this.displayDialog = false;
        this.retrieveUsers();
      },
      (error) => {
        this.displayDialog = false;
        this.showMsg('warning', 'Rejected', 'Error happened while User Creation!!!');
      });
  }

  updateUser() {

    this.salesService.updateUser(this.userDTO).subscribe(
      (data) => {
        this.showMsg('info', 'Confirmed', 'User Details Modified Successfully !!!');
        this.displayDialog = false;
        this.retrieveUsers();
      },
      (error) => {
        this.displayDialog = false;
        this.showMsg('warning', 'Rejected', 'Error happened while User details modification!!!');
      });
  }

  onSubmit(event) {
    for (let controller in this.myGroup.controls) {
      this.myGroup.get(controller).markAsTouched();
    }

    if (event.submitter.id == "finish") {
      if (this.f.valid) {
        var quota = <HTMLInputElement>document.getElementById("quota");
        this.userDTO.quota = parseInt(quota.value);

        if (this.userId != -1) {
          this.displayDialog = false;
          this.updateUser();
        }
        else {
          this.displayDialog = false;
          this.createUser();
        }
      }
    }
  }

  public userId: number = -1;

  addPermission(event) {

    for (let controller in this.myPermissionGroup.controls) {
      this.myPermissionGroup.get(controller).markAsTouched();
    }

    if (this.myPermissionGroup.valid) {

      for (let index = 0; index < this.usersList.length; index++) {
        const element = this.usersList[index];
        if (element.userId == this.userId) {
          this.userPermission.user = element;
          break;
        }
      }
      var lob = <HTMLInputElement>document.getElementById("lob");
      this.userPermission.lob = lob.value;

      this.addUserPermission(this.userPermission);
    }
  }

  addUserPermission(userPermission: UserPermissions) {

    let permExists = false;
    for (var i = 0; i < this.userPermissionList.length; i++) {
      const ele = this.userPermissionList[i];
      if (ele.sector.sectorId == userPermission.sector.sectorId && ele.region.regionId == userPermission.region.regionId) {
        permExists = true;
        break;
      }
    }
    if (permExists) {
      this.showPermMsg('error', 'Rejected', 'Permission already Exists!!!');
    }
    else {
      this.salesService.createPermission(userPermission).subscribe(
        (data) => {
          this.showPermMsg('info', 'Confirmed', 'User Permission added!!!');
          this.addPermissionRowClass = "addPermissionRowClass";
          this.salesService.retrievePermissions(this.userId).toPromise().then(response => {this.userPermissionList = response; });
        },
        (error) => {
          this.showPermMsg('warning', 'Rejected', 'Error happened while adding permission!!!');
        });
    }
  }

  enableAddPermissionRow(event) {
    this.addPermissionRowClass = "";
    this.userPermission = new UserPermissions();
    let users = new Users();
    users.userId = this.userId;
    this.userPermission.user = users;
    this.hideSector = true;
    this.hideRegion = true;
    this.createForm();
    this.myPermissionGroup.reset();
    var lob = <HTMLInputElement>document.getElementById("lob");
    lob.value = "";
  }

  disableAddPermissionRow(event) {
    this.createForm();
    this.myPermissionGroup.reset();
    this.addPermissionRowClass = "addPermissionRowClass";
  }

  public openPermissionDialog(event, userId) {
    this.displayPermDialog = true;
    this.displayDialog = false;
    this.userId = userId;
    this.addPermissionRowClass = "addPermissionRowClass";
    this.createForm();
    this.myPermissionGroup.reset();
    this.salesService.retrievePermissions(userId).toPromise().then(response => { this.userPermissionList = response; });

    (async () => {
      await this.delay(500);

      if (this.userPermissionList.length <= 0) {
        this.addPermissionRowClass = "";
      }
    })();
  }

  deletePermission(event, ruleId) {

    this.confirmationService.confirm({
      message: 'Do you want to delete the Permission?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.deleteUserPermission(ruleId);
      },
      reject: () => { }
    });
  }

  public deleteUserPermission(ruleId: number) {
    this.salesService.deletePermission(ruleId).subscribe(
      (data) => {
        this.deleteUserPermissionRow(ruleId);
        this.showPermMsg('info', 'Confirmed', 'User Permission deleted');
      },
      (error) => {
        this.showPermMsg('warning', 'Rejected', 'Error happened while deleting!!!');
      });
  }

  public deleteUserPermissionRow(id: number) {
    var index = 0;
    for (var i = 0; this.userPermissionList; i++) {
      if (this.userPermissionList[i].ruleId == id) {
        index = i;
        break;
      }
    }
    this.userPermissionList = this.userPermissionList.slice(0, index).concat(this.userPermissionList.slice(index + 1));
  }

  ClosePermissionDialog() {

    this.displayPermDialog = false;
    this.userPermissionList = [];
  }

  public openAddUserDialog(event) {

    this.displayDialog = true;
    this.userId = -1;
    this.clearUserDTO();
    this.addEditUserHeader = "Create User";
    this.createForm();
    this.myGroup.reset();
    this.f.resetForm(this.f.value);
  }

  clearUserDTO() {
    this.userDTO  = {
       userId: null,
       empId: null,
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        managerId: null,
        quota: null,
        status: 0,
        region: '',
        manager: '',
        role: {
            roleId: null,
            userRole: '',
            userManagement: false,
            customerManagement: false,
            lookupManagement: false,
            techLeadAccess: false
        },
        appliancesRole: {
            roleId: null,
            roleName: '',
            orderManagement: false,
            stockManagement: false,
            inventoryManagement: false,
            fileProcessingManagement: false,
            RFPManagement: false,
            prospectsManagement: false,
            accessLevel: 0
        }
    };
  }

  public addEditUserHeader = "Create User";

  public editUserData(editUserId: any) {
    this.userId = editUserId;
    this.displayDialog = true;
    this.userDTO = new Users();
    this.addEditUserHeader = "Modify User Details";
    this.createForm();
    this.myGroup.reset();

    for (var i = 0; this.usersList; i++) {
      if (this.usersList[i].userId == editUserId) {
        this.userDTO = this.usersList[i];
        break;
      }
    }

    this.myGroup.controls.empId.setValue(this.userDTO.empId);
    this.myGroup.controls.firstName.setValue(this.userDTO.firstName);
    this.myGroup.controls.lastName.setValue(this.userDTO.lastName);
    this.myGroup.controls.email.setValue(this.userDTO.email);
    this.myGroup.controls.manager.setValue(this.userDTO.managerId);
    this.myGroup.controls.quota.setValue(this.userDTO.quota);
    this.myGroup.controls.role.setValue(this.userDTO.role.roleId);
    this.myGroup.controls.applanceRole.setValue(this.userDTO.appliancesRole.roleId);
  }

  public onDeleteUser(oppId: number) {
    this.confirmationService.confirm({
      message: 'Do you want to delete the User?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.deleteUser(oppId);
      },
      reject: () => { }
    });
  }

  public deleteUser(oppId: number) {
    this.salesService.deleteUser(oppId).subscribe(
      (data) => {
        this.deleteUserRow(oppId);
        this.showMsg('info', 'Confirmed', 'User deleted');
      },
      (error) => {
        this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!    Tip: You can not delete a user that already has an opportunity.');
      });
  }

  public deleteUserRow(id: number) {
    var index = 0;
    for (var i = 0; this.usersList; i++) {
      if (this.usersList[i].userId == id) {
        index = i;
        break;
      }
    }
    this.usersList = this.usersList.slice(0, index).concat(this.usersList.slice(index + 1));
  }

  public showMsg(severity: string, summary: string, detail: string) {
    this.msgs = [{ severity: severity, summary: summary, detail: detail }];
    setTimeout(() => { this.msgs = [] }, 2000);
  }

  public showBrandMsg(severity: string, summary: string, detail: string) {
    this.brandsMsgs = [{ severity: severity, summary: summary, detail: detail }];
    setTimeout(() => { this.brandsMsgs = [] }, 2000);
  }
  public showPermMsg(severity: string, summary: string, detail: string) {
    this.permMsgs = [{ severity: severity, summary: summary, detail: detail }];
    setTimeout(() => { this.permMsgs = [] }, 3000);
  }

  public showTagMsg(severity: string, summary: string, detail: string) {
    this.tagMsgs = [{ severity: severity, summary: summary, detail: detail }];
    setTimeout(() => { this.tagMsgs = [] }, 3000);
  }

  public closeDialog(event) {
    this.clearUserDTO();
    this.displayDialog = false;
  }

  isBrandLead(roleId) {
    return roleId == 3;
  }

  selectItem(item: ProductItem, userId) {
    let isBrandLead = false;
    for (var i = 0; i < this.brandListUsers.length; i++) {
      var array_element = this.brandListUsers[i];
      if (array_element.itemId.itemId == item.itemId && array_element.userId.userId == parseInt(userId)) {
        isBrandLead = true;
        break;
      }
    }
    return isBrandLead;
  }

  addBrandLeadUserItem(brandLead) {

    this.salesService.addBrandLeadUserItem(brandLead).subscribe(
      (data) => {
        this.displayDialog = false;
        this.showBrandMsg('info', 'Confirmed', 'Item Added Successfully!!!');
      },
      (error) => {
        this.showBrandMsg('warning', 'Rejected', 'Error happened while adding Item to brand lead User!!!');
      });
  }

  async deleteBrandLeadUserItem(brandLead) {

    this.salesService.deleteBrandLeadUserItem(brandLead.brandId).subscribe(
      (data) => {
        this.showBrandMsg('info', 'Confirmed', 'Item Removed Successfully!!!',);
        this.displayDialog = false;
      },
      (error) => {
        this.showBrandMsg('warning', 'Rejected', 'Error happened while removing Item !!!');
      });
  }

  async AddUpdateBrandLeadUser(event, userId, itemId) {
    let currentBrandLead;
    currentBrandLead = getCurrentBrandLead(this.brandListUsers, this.usersList, userId, itemId, currentBrandLead);

    if (event.target.checked) {
      this.addBrandLeadUserItem(currentBrandLead);
    }
    else {
      await this.deleteBrandLeadUserItem(currentBrandLead);
    }

    (async () => {
      await this.delay(1000);

      await this.retrieveUsers();
      await this.retrieveBrandLeadUsers();
    })();
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public openTagsDialog(event, userId) {
    // Disable scrolling when dialog opens
    $("body").css("overflow-y", "hidden");

    this.displayTagsDialog = true;
    this.selectedUserId = userId;
    this.userTags = [];
    this.selectedTags = [];

    // Find user to get their name for the dialog title
    for (const user of this.usersList) {
      if (user.userId === userId) {
        this.currentUsername = `${user.firstName} ${user.lastName}`;
        break;
      }
    }

    // Load user's tags
    this.salesService.getTagsByUserId(userId).subscribe(
      (data) => {
        this.userTags = data;
      },
      (error) => {
        this.showTagMsg('error', 'Error', 'Failed to load user tags');
      }
    );

    // Load all tag types
    this.salesService.getAllTagTypes().subscribe(
      (data) => {
        this.tagTypes = data;
        if (this.tagTypes.length > 0) {
          this.selectedTagType = this.tagTypes[0];
          // Load available tags for the initially selected tag type
          this.loadTagsByType(this.selectedTagType);
        }
      },
      (error) => {
        this.showTagMsg('error', 'Error', 'Failed to load tag types');
      }
    );
  }

  loadTagsByType(tagType: string) {
    this.salesService.getTagsByType(tagType).subscribe(
      (data) => {
        // Filter out tags that are already assigned to the user
        if (this.userTags && this.userTags.length > 0) {
          const userTagIds = this.userTags.map(tag => tag.id);
          this.availableTags = data.filter(tag => !userTagIds.includes(tag.id));
        } else {
          this.availableTags = data;
        }
      },
      (error) => {
        this.showTagMsg('error', 'Error', 'Failed to load available tags');
      }
    );
  }

  onTagTypeChange(event) {
    this.selectedTagType = event.value;
    this.loadTagsByType(this.selectedTagType);
    this.selectedTags = []; // Reset selected tags when changing type
  }

  addTagToUser() {
    if (this.selectedTags && this.selectedTags.length > 0) {
      this.salesService.addTagsToUser(this.selectedUserId, this.selectedTags).subscribe(
        (data) => {
          this.showTagMsg('info', 'Success', 'Tags added successfully');

          // Refresh user tags
          this.salesService.getTagsByUserId(this.selectedUserId).subscribe(
            (data) => {
              this.userTags = data;

              // Filter out the newly added tags from availableTags
              if (this.selectedTags.length > 0) {
                this.availableTags = this.availableTags.filter(tag => !this.selectedTags.includes(tag.id));
              }

              // Reset selected tags
              this.selectedTags = [];
            }
          );
        },
        (error) => {
          this.showTagMsg('error', 'Error', 'Failed to add tags');
        }
      );
    } else {
      this.showTagMsg('warn', 'Warning', 'Please select at least one tag');
    }
  }

  removeTagFromUser(tagId: number) {
    this.salesService.deleteTagFromUser(this.selectedUserId, tagId).subscribe(
      (data) => {
        this.showTagMsg('info', 'Success', 'Tag removed successfully');
        // Update the userTags array by filtering out the removed tag
        const removedTag = this.userTags.find(tag => tag.id === tagId);
        this.userTags = this.userTags.filter(tag => tag.id !== tagId);

        // Add the removed tag back to the availableTags list if it matches the current tag type
        if (removedTag && removedTag.tagType === this.selectedTagType) {
          this.availableTags = [...this.availableTags, removedTag];
        }

        // Reload tags for the current type to ensure consistency
        this.loadTagsByType(this.selectedTagType);
      },
      (error) => {
        this.showTagMsg('error', 'Error', 'Failed to remove tag');
      }
    );
  }

  closeTagsDialog() {
    this.displayTagsDialog = false;
    // Re-enable scrolling when dialog closes
    $("body").css("overflow-y", "auto");
  }
}

function getCurrentBrandLead(ruleUser, userList, id, currentCheckboxId, currentBrandLead) {

  for (var i = 0; i < ruleUser.length; i++) {
    var elementid = ruleUser[i].userId.userId;
    var itemid = ruleUser[i].itemId.itemId;
    if (elementid == id && itemid == currentCheckboxId) {
      currentBrandLead = ruleUser[i];
      break;
    }
  }
  if (currentBrandLead == undefined || currentBrandLead == null) {

    var userBrand = "";
    for (let user of userList) {
      if (user.userId == id) {
        userBrand = user;
        break;
      }
    }

    currentBrandLead = [];
    currentBrandLead.push(
      {
        brandId: 0,
        itemId: { itemId: currentCheckboxId },
        userId: userBrand
      }
    );
    currentBrandLead = currentBrandLead[0];
  }
  return currentBrandLead;
}

function populateManagerName(managerId: number, usersList: Users[], userData: Users) {
  for (var j = 0; j < usersList.length; j++) {
    var option = usersList[j];
    if (option.userId === managerId) {
      userData.manager = option.firstName + " " + option.lastName;
      break;
    }
  }
}
